// src/vocabulary/C1/unit2/content.js

const content = {
  level: "C1",
  unit: 2,
  title: "Social Issues & Society",
  description:
    "Advanced vocabulary related to social issues, inequality, education, and the influence of society on individuals.",

  explanation: [
    "This unit focuses on major social issues that affect modern societies.",
    "You will learn vocabulary used to discuss inequality, education, and social pressure.",
    "These words often appear in news articles, debates, and academic discussions.",
    "At C1 level, learners should express complex ideas clearly and logically.",
    "You may need to explain causes, effects, and possible solutions.",
    "For example: Social inequality can limit access to education.",
    "Using this vocabulary helps you discuss society in a thoughtful way.",
    "Try to express an opinion about a social issue and support it with reasons."
  ],

  items: [
    {
      word: "inequality",
      phonetic: "/ˌɪnɪˈkwɒləti/",
      meaning: "a systemic disparity in the distribution of resources, opportunities, or rights among individuals or social groups",
      example: "Social inequality continues to hinder progress in many communities."
    },
    {
      word: "education system",
      phonetic: "/ˌedʒuˈkeɪʃn ˈsɪstəm/",
      meaning: "the institutionalized framework through which a society formally transmits knowledge, values, and skills across generations",
      example: "The education system must adapt to the demands of a changing economy."
    },
    {
      word: "social pressure",
      phonetic: "/ˈsəʊʃl ˈpreʃər/",
      meaning: "the compelling influence exerted by peer groups or societal norms that drives individuals toward conformity or compliance",
      example: "Adolescents are particularly vulnerable to social pressure."
    },
    {
      word: "opportunity",
      phonetic: "/ˌɒpəˈtjuːnəti/",
      meaning: "a favorable set of circumstances that enables the pursuit of advancement, achievement, or access to resources",
      example: "Equal access to education creates equitable opportunities for all citizens."
    },
    {
      word: "discrimination",
      phonetic: "/dɪˌskrɪmɪˈneɪʃn/",
      meaning: "the unjust differential treatment of individuals based on characteristics such as race, gender, or socioeconomic status",
      example: "Discrimination in the workplace undermines both morale and productivity."
    },
    {
      word: "social responsibility",
      phonetic: "/ˈsəʊʃl rɪˌspɒnsəˈbɪləti/",
      meaning: "the ethical obligation of individuals or institutions to act in ways that benefit society and minimize harm to others",
      example: "Corporations are increasingly expected to demonstrate social responsibility."
    }
  ]
};

export default content;
